export default "__VITE_ASSET__BZZ97oEh__"